import { render, staticRenderFns } from "./BanksCatalog.vue?vue&type=template&id=9506976c&scoped=true&"
import script from "./BanksCatalog.vue?vue&type=script&lang=js&"
export * from "./BanksCatalog.vue?vue&type=script&lang=js&"
import style0 from "./BanksCatalog.vue?vue&type=style&index=0&id=9506976c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9506976c",
  null
  
)

export default component.exports